import React from "react";
import documentPdf from "../assets/svg/document-pdf.svg";
import Image from "@vfuk/core-image";
import { useTranslation } from "react-i18next";

export const DocumentPdf = () => {
  const { t } = useTranslation();

  return (
    <Image
      alt={t("core:common:pdf_placeholder")}
      sm={{
        src: documentPdf,
      }}
    />
  );
};
